export class ApplicationState {
    initialized = false;
    authenticationError: string;
    currentUser: firebase.User;
};